/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ group: NonNullable<unknown> }} Movement_Breakdown_Chart_TitleInputs */

const vi_movement_breakdown_chart_title = /** @type {(inputs: Movement_Breakdown_Chart_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Biến động nhập/xuất theo ${i?.group}`)
};

/**

* @param {Movement_Breakdown_Chart_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const movement_breakdown_chart_title = /** @type {((inputs: Movement_Breakdown_Chart_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Movement_Breakdown_Chart_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_movement_breakdown_chart_title(inputs)
});